module.exports = __webpack_public_path__ + "img/loginLeftBG.2a635612.png";